export default __webpack_public_path__ + "static/media/Sellers tab_open house(2).45af6c6b.jpg";